import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Modal } from "bootstrap";
import { isOverlayShellOpen } from "../View/ProductHybrid/productOverlay/useOverlayShell";

function ModalCleanup() {
  const location = useLocation();

  useEffect(() => {
    const modalEl = document.querySelector(".modal.show");
    const staleBackdrops = Array.from(document.querySelectorAll(".modal-backdrop"));

    if (modalEl) {
      const modalInstance = Modal.getInstance(modalEl) || new Modal(modalEl);
      setTimeout(() => {
        modalInstance.hide();
      }, 350);
    }
    setTimeout(() => {
      staleBackdrops.forEach((b) => b.remove());
      if (document.querySelector(".modal-backdrop")) return;
      document.body.classList.remove("modal-open");
      if (!isOverlayShellOpen()) document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }, 350);
  }, [location.pathname]);

  return null;
}

export default ModalCleanup;
